/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {RawParams, StateDeclaration} from '@uirouter/core';
import * as _ from 'lodash';

export interface AuthReturnNavigation {
  toState: StateDeclaration;
  toParams: RawParams;
}

@Injectable({providedIn: 'root'})
export class AuthReturnNavigationService {
  private navigation: AuthReturnNavigation | null = null;

  remember(toState: StateDeclaration | null | undefined, toParams: RawParams | null | undefined): void {
    if (!toState?.name || toState.data?.public) {
      return;
    }
    this.navigation = {
      toState,
      toParams: _.cloneDeep(toParams || {})
    };
  }

  get(): AuthReturnNavigation | null {
    return this.navigation;
  }

  clear(): void {
    this.navigation = null;
  }
}
